<template>

  <b-overlay
    :show="showOverlay"
    rounded="sm"
  >

    <category-list-add-new
      :is-add-new-product-category-sidebar-active.sync="isAddNewProductCategorySidebarActive"
      @refetch-data="refetchProductCategoryData"
    />

    <template>

      <b-row>

        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >

          <template>

            <!-- Table Container Card -->
            <b-card
              no-body
            >

              <div class="m-2">
                <!-- Table Top -->
                <b-row>
                  <!-- Per Page -->
                  <b-col
                    cols="12"
                    md="6"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                  >
                    <label>Entries</label>
                    <v-select
                      v-model="perPage"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="perPageOptions"
                      :clearable="false"
                      class="per-page-selector d-inline-block ml-50 mr-1"
                    />
                  </b-col>
                  <!-- Add -->
                  <b-col
                    class="d-flex align-items-center justify-content-end"
                    cols="12"
                    md="6"
                  >
                    <b-button
                      v-if="$can('create', 'category')"
                      variant="primary"
                      @click="isAddNewProductCategorySidebarActive = true"
                    >
                      Toevoegen
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <b-table
                ref="refCategoriesListTable"
                :items="fetchCategories"
                responsive
                :fields="tableColumns"
                primary-key="id"
                :sort-by.sync="sortBy"
                :sort-desc.sync="isSortDirDesc"
                show-empty
                empty-text="Geen overeenkomende records gevonden"
                class="position-relative categorie-table"
              >

                <!-- Column: Id -->
                <template #cell(id)="data">
                  <b-link
                    :to="{ name: 'app-category-list-edit', params: { id: data.item.id }}"
                    class="font-weight-bold"
                  >
                    #{{ data.value }}
                  </b-link>
                </template>

                <!-- Column: Category -->
                <template #cell(name)="data">
                  <b-media vertical-align="center">
                    <template #aside>
                      <b-avatar
                        size="32"
                        :src="data.item.avatar"
                        :text="avatarText(data.item.name)"
                        :to="{ name: 'app-category-list-edit', params: { id: data.item.id } }"
                      />
                    </template>
                    <b-link
                      :to="{ name: 'app-category-list-edit', params: { id: data.item.id } }"
                      class="font-weight-bold d-block text-nowrap"
                    >
                      {{ data.item.name }}
                    </b-link>
                    <div class="text-muted">
                      {{ data.item.createdDate }}
                    </div>
                  </b-media>
                </template>

                <!-- Column: Actions -->
                <template #cell(actions)="data">

                  <div class="text-nowrap">
                    <b-link
                      :id="`product-category-view-action-row-${data.item.id}`"
                      :to="{ name: 'app-category-list-edit', params: { id: data.item.id }}"
                    >
                      <feather-icon
                        :id="`product-category-row-${data.item.id}-preview-icon`"
                        class="cursor-pointer mx-1"
                        icon="EyeIcon"
                        size="16"
                      />
                    </b-link>
                    <b-tooltip
                      :target="`product-category-view-action-row-${data.item.id}`"
                      placement="top"
                    >
                      <p class="mb-0">
                        Aanpassen
                      </p>
                    </b-tooltip>
                    <feather-icon
                      :id="`product-category-row-${data.item.id}-delete-icon`"
                      class="cursor-pointer"
                      size="16"
                      icon="TrashIcon"
                      @click="confirmProductCategoryDeleteText(data.item.id)"
                    />
                    <b-tooltip
                      :target="`product-category-row-${data.item.id}-delete-icon`"
                      placement="top"
                    >
                      <p class="mb-0">
                        Verwijderen
                      </p>
                    </b-tooltip>
                  </div>
                </template>

              </b-table>
            </b-card>

          </template>

        </b-col>

        <b-col
          cols="12"
          md="6"
          xl="6"
          lg="6"
        />

      </b-row>

    </template>

  </b-overlay>

</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BTable,
  BLink,
  BMedia,
  BAvatar,
  BOverlay,
  BTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import useCategoryList from '@/views/pages/products/category/useCategoryList'
import CategoryListAddNew from '@/views/pages/products/category/category-add/CategoryListAddNew.vue'
import productOrganisationStoreModule from '@/views/pages/products/category/productOrganisationStoreModule'

export default {
  components: {
    CategoryListAddNew,
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    vSelect,
    BOverlay,
    BTooltip,
  },
  methods: {
    confirmProductCategoryDeleteText(id) {
      this.$swal({
        title: 'Weet je het zeker?',
        text: 'U kunt dit niet meer terugdraaien!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, verwijder het!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          store.dispatch('app-category-list/deleteProductCategory', { id })
            .then(() => {
              this.refetchProductCategoryData()
              this.$swal({
                icon: 'success',
                title: 'Verwijderd!',
                text: 'De productcategorie is verwijderd.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
        }
      })
    },
  },
  setup() {
    const INVOICE_APP_STORE_MODULE_NAME = 'app-category-list'

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, productOrganisationStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    const isAddNewProductCategorySidebarActive = ref(false)

    const {
      fetchCategories,
      tableColumns,
      perPage,
      currentPage,
      totalCategories,
      dataMeta,
      perPageOptions,
      sortBy,
      refCategoriesListTable,
      isSortDirDesc,
      refetchProductCategoryData,
      showOverlay,
    } = useCategoryList()

    return {
      isAddNewProductCategorySidebarActive,
      fetchCategories,
      tableColumns,
      perPage,
      currentPage,
      totalCategories,
      dataMeta,
      perPageOptions,
      sortBy,
      refCategoriesListTable,
      isSortDirDesc,
      refetchProductCategoryData,
      avatarText,
      showOverlay,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }

  .categorie-table{
    .description{
      width:30%;
    }
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
